import React from 'react'
import { Link } from 'react-static'

const Nav = ({ data }) => [
  <header className="header" key="header">
    <h1>{data.header}</h1>
  </header>,
  <nav key="nav">
    <Link exact to="/" activeClassName="selected">Welcome</Link>
    <Link to="/pictures" activeClassName="selected">Pictures</Link>
    <Link to="/activities" activeClassName="selected">Activities</Link>
    <Link to="/bedrooms" activeClassName="selected">Bedrooms</Link>
    <Link to="/area" activeClassName="selected">Day Trips / Area Map</Link>
    <Link to="/reviews" activeClassName="selected">Guest Comments</Link>
  </nav>,
]

export default Nav



// WEBPACK FOOTER //
// /opt/build/repo/src/components/Nav.js